<template>
	<b-modal
		id="modal-quote"
		v-model="showModal"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		size="lg"
	>
		<progress-bar :progress="progress" />

		<b-container
			class="modal-body-content clearfix"
			fluid
		>
			<b-row class="justify-content-center">
				<b-col>
					<h1 class="form-heading">
						{{ formHeading }}
					</h1>
				</b-col>
			</b-row>

			<b-row class="justify-content-between">
				<b-col
					class="form-container"
					order="1"
					order-md="0"
				>
					<b-form
						class="inline-form"
						@submit.prevent="onSubmit"
					>
						<div
							:class="!isVerificationPage ? 'quote-form' : ''"
							class="text-left"
						>
							<transition
								name="fade"
								mode="out-in"
							>
								<router-view>
									<button
										slot="submitButton"
										:disabled="loading"
										class="btn"
										type="submit"
									>
										<div
											v-if="loading"
											class="loader"
										></div>
										{{ !loading ? buttonText : '' }}
									</button>
								</router-view>
							</transition>
						</div>
					</b-form>
				</b-col>

				<b-col
					v-if="showQuoteSteps"
					class="quote-steps"
					cols="12"
					md="1"
				>
					<progress-steps
						:step="step"
						:on-change="onStepChange"
					/>
				</b-col>
			</b-row>
			<b-row v-if="isPhonePage">
				<b-col>
					<p id="tcpa-statement">
						Your privacy is important and your information is
						protected by 256 bit encryption! Typing your name and
						clicking 'Get Quotes' gives your express consent to be
						contacted directly by one of our affiliates, including
						one or more of the companies below, which may be through
						the use of an automated dialer, via prerecorded calls
						and/or text messages, including cell phones, even if I
						am on a DNC list. Consent is not a condition of
						purchase.
					</p>
				</b-col>
			</b-row>
		</b-container>
	</b-modal>
</template>

<script>
import { mapState } from 'vuex';

const steps = () =>
	import(/* webpackChunkName: "components-Quote" */ '@/common/steps');
const progressbar = () =>
	import(/* webpackChunkName: "components-Quote" */ '@/common/progressbar');

export default {
	name: 'Quote',
	components: {
		'progress-steps': steps,
		'progress-bar': progressbar,
	},
	data: function() {
		return {
			buttonText: 'Continue',
			current_step: 'name',
			isPhonePage: false,
			isVerificationPage: false,
			showModal: false,
			showProgress: false,
			loading: false,
			timeout: null,
			redirect_url: null,
			validateFields: [],
		};
	},
	computed: {
		...mapState({
			quote: state => state.quote,
			validator: state => state.validator,
			step: state => state.progress.completed_steps,
		}),
		hasValidFields() {
			const vm = this;

			return this.$iUtils.every(
				this.validateFields,
				fieldName => vm.validator[fieldName].isValid
			);
		},
		formHeading() {
			let heading = 'Get ready to view your quote!';

			if (this.isVerificationPage) {
				heading = `
					Next: Our system will display your quote.
				`;
			} else if (this.showAutoInterest) {
				heading
				= 'Your moving quote is being processed... But one more thing.';
			}

			return heading;
		},
		progress() {
			return this.$store.getters['progress/getProgress'](this.step);
		},

		showQuoteSteps() {
			return !this.isVerificationPage && !this.showAutoInterest;
		},
	},
	watch: {
		$route: {
			immediate: true,
			handler(to) {
				this.$log.debug(to);

				this.isPhonePage = false;
				this.isVerificationPage = false;

				if (!this.$iUtils.isEmpty(to.meta)) {
					this.validateFields = to.meta.validateFields;
				}

				if (to.name === 'Quote-Phone') {
					this.buttonText = 'Get Quotes!';
					this.isPhonePage = true;
				} else if (to.name === 'Quote-Text-Verify') {
					this.isVerificationPage = true;
				}
			},
		},

		// Add a watcher for the 'loading' property since it shouldn't run longer than 5s
		loading(to, from) {
			if (to && !from) {
				this.timeout = setTimeout(() => {
					if (this.loading) {
						this.loading = false;
					}
				}, 5000);
			} else if (this.timeout) {
				clearTimeout(this.timeout);
			}
		},

		validator: {
			deep: true,
			handler(to) {
				this.$log.debug('watch::validator | ', to);

				if (to.textVerify.isValid) {
					// this.nextStep();
					this.next();
				} else if (this.isPhonePage && to.phone.isValid) {
					this.onSubmit();
				}
			},
		},
	},
	created: function() {
		this.$store.dispatch('validator/init');

		const delay = !this.$store.state.iframeFlag ? 4000 : 0;

		setTimeout(() => {
			this.showModal = true;
		}, delay);
	},
	mounted: function() {
		this.$store.dispatch('progress/updateProgress', this.step);

		// document.addEventListener('mousemove', this.mouseleave);

		this.$root.$on('call-movers-closed', () => {
			this.showModal = true;
		});
	},
	beforeDestroy() {
		// document.removeEventListener('mousemove', this.mouseleave);
	},
	methods: {
		onSubmit() {
			const _formControl = this.$el.querySelector('.form-control');

			if (this.hasValidFields) {
				this.error = '';

				if (this.isPhonePage) {
					this.submitForm();
				} else {
					this.nextStep();
				}
			} else {
				_formControl.dispatchEvent(new Event('input'));
				_formControl.dispatchEvent(new Event('keyup'));
			}
		},

		/**
		 * When the user moves their mouse outside the window (at the top)
		 * we want to trigger the event that will show the CM modal.
		 *
		 * @param {Event} evt blah blah
		 * @returns {void} blah
		 *
		 */
		mouseleave(evt) {
			// this.$log.debug(evt);

			if (evt.clientY < 5) {
				this.$root.$emit('show-call-movers');
			}
		},
		nextStep() {
			const name = this.$store.getters['progress/getNextStep'].name;

			this.$log.debug(name);

			this.$router.push({ name });
		},
		submitForm(isResubmit = false) {
			// Don't try to submit again if one is still in progress
			if (this.loading) {
				return;
			}

			this.loading = true;

			this.$store
				.dispatch('quote/submitLead', { leadType: 'move', isResubmit })
				.then(data => {
					this.$log.info('submitForm -> ', data);
					this.loading = false;

					if (data.status === 'success' || data.status === 200) {
						window._vis_opt_queue = window._vis_opt_queue || [];
						window._vis_opt_queue.push(function() {
							window._vis_opt_goal_conversion(206);
						});

						if (this.$store.state.iframeFlag) {
							this.next();
						} else if (
							data.require_text_verify
							&& data.lead_state === 'text_verification'
						) {
							this.$store.dispatch('quote/update', {
								textVerifyId: data.text_id,
							});

							this.nextStep();
						}
					}
				})
				.catch(errorRes => {
					this.loading = false;

					if (
						errorRes.response
						&& errorRes.response === 'lead has already been submitted'
					) {
						this.submitForm(true);
					} else if (errorRes.missing) {
						this.$toastr('error', errorRes.missing, 'Error!');
					} else {
						this.$log.error('submitForm | ', errorRes, this.quote);
						this.$session.destroy();
						window.location.replace(
							`/secure?source=${this.quote.source}`
						);
					}
				});
		},
		next: function() {
			if (
				process.env.VUE_APP_DEBUG !== 'true'
				&& !this.$store.state.iframeFlag
			) {
				const leadToken = this.quote.tokens.move;

				this.$analytics.page('Thank_You', { path: 'Thank_You' });

				this.$session.destroy();

				window.location.href = this.redirect_url
					? this.redirect_url
					: `https://my.topmoving.com/thank-you/${leadToken}`;
			} else {
				this.$router.replace({ name: 'Thank-You' });
			}
		},
		onStepChange: function(step) {
			const route = this.$store.getters['progress/getStepByIndex'](step);

			this.$log.debug(route);

			if (route) {
				this.$router.push(route);
			}
		},
	},
};
</script>

<style lang="scss">
@import '~@/../node_modules/bootstrap/scss/bootstrap-reboot';

#modal-quote {
	padding-right: 0 !important;

	.modal-dialog {
		// top: 50%;
		// transform: translate(0, -50%);
		// Don't try to center modal vertically as the modal will grow
		// and will cause a shift in position
		margin: 0 auto;
		margin-top: 8vh;
		max-width: 360px;
	}

	.modal-header,
	.modal-footer {
		display: none !important;
	}

	.modal-body {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	.modal-body-content {
		margin: 1rem 0;

		.form-container {
			min-width: 85%;
		}

		.inline-form {
			margin: 0.5rem 0;
			width: 100%;
		}
	}

	.progress {
		border-top-left-radius: 4px !important;
		border-top-right-radius: 4px !important;
		left: 1px;
		position: absolute;
		top: 0;
		width: 99.8%;
	}
}

.quote-text-verify-page {
	.modal-body-content {
		.form-container {
			max-width: 100% !important;
			width: 100%;
		}
	}
}

.form-heading {
	color: #e05535;
	font-size: 30px;
	font-weight: 600;
	line-height: 1.25;
	text-align: center;

	&.vehicle {
		font-size: 1.4rem;
	}

	span {
		color: #4a4a4a;
	}
}

.form-row {
	display: block !important;
	margin: 30px -10px 0 !important;
}

.form-input {
	margin: 1.5rem 0 0;
}

.form-button {
	margin: 1rem 0 0;
}

.sec-hd.gray {
	color: #8a8a8a;
	font-size: 1rem;
}

hr {
	border: none !important;
	display: flex;
}

.sec-hd {
	color: #3bb671;
	font-size: 0.9rem;
}

.progress-outer,
.progress-inner {
	background: #f5f5f5;
	border-radius: 4px;
	height: 6px;
	width: 100%;
}

.progress-inner {
	background: #3bb671;
}

.input-wrap {
	// float: left;
	position: relative;
	width: 55%;
}

#tcpa-statement {
	color: #9e9e9e;
	font-size: 12px;
	line-height: 16px;
	margin: 1rem 0;
	text-align: center;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	#tcpa-statement {
		color: #d8d8d8;
	}
}

@include media-breakpoint-only(sm) {
	#modal-quote {
		.modal-dialog {
			max-width: 520px;
		}
	}
}

@include media-breakpoint-down(sm) {
	.form-button {
		display: flex !important;
		justify-content: center !important;
	}

	.form-heading {
		font-size: 1.4rem;
	}
}

@include media-breakpoint-up(md) {
	#modal-quote {
		.modal-dialog {
			margin-top: 25vh;
			max-width: 720px;
		}

		.modal-body-content {
			.form-container {
				max-width: 85%;
			}
		}

		.form-button {
			margin: 1.5rem 0 0;
		}
	}
}

@include media-breakpoint-up(lg) {
	#modal-quote {
		.modal-dialog {
			max-width: 840px;
		}
	}
}

// .info .inline-form button {
// 	display: block;
// 	margin: 20px auto;
// }
</style>
